import { useCurrentURL } from "../hooks/ContextualNavigations";
import { AtemApplication } from "../modules/user/domain/constants";
import { decryptParams } from "./obfuscate";
import config from "../config/default";

export enum applicationListRules {
  PORTAL_TRADING = "portal_trading",
}

const applicationList = {
  suprimentos: AtemApplication.SUPPLY_CHAIN,
  comercial: AtemApplication.SALES_PORTAL,
  portal: AtemApplication.CUSTOMER_PORTAL,
  checklist: AtemApplication.CHECKLIST,
  carregamento: AtemApplication.LOADING,
  vendas: AtemApplication.SALES,
};

export const CurrentApplication = () => {
  const params = useCurrentURL();

  if (config.isIDP) {
    return AtemApplication.IDP;
  }

  const subdomain = params.url.replace(/^https?:\/\//, "").split(".")[0];

  for (const key in applicationListRules) {
    const rulesValue = applicationListRules[key];
    if (params?.rules?.includes(rulesValue)) return applicationListRules[key];
  }

  for (const item of Object.keys(applicationList)) {
    if (subdomain.includes(item)) {
      return applicationList[item] as AtemApplication;
    }
  }
  return AtemApplication.CUSTOMER_PORTAL;
};

export const showPass = (showPass: boolean) => {
  return showPass ? "text" : "password";
};

export const getParams = async () => {
  const hash = window.location.hash || "";

  const [, rawParams] = hash.split("?");

  if (!rawParams) {
    const message = "Nenhum parâmetro encontrado no hash:";
    console.warn(message, hash);
    return {};
  }

  const queryString = new URLSearchParams(rawParams);

  const queryParams = Object.fromEntries(queryString.entries());

  const encryptedPayload = queryString.get("payload");

  if (encryptedPayload) {
    try {
      const decrypted = await decryptParams(encryptedPayload);
      return { ...queryParams, ...decrypted };
    } catch (e) {
      console.error("Erro ao descriptografar payload. ", e);
      return queryParams;
    }
  }

  return queryParams;
};
